export default "__VITE_ASSET__41rfn3lR__"